import React, { Component, PropTypes} from 'react'
import CSSModules from 'react-css-modules'
import {Link as RouterLink} from 'react-router'
import Styles from './Link.css'
import config from 'config'
import analytics from '../../helpers/analytics'
// import LinkedInTag from 'react-linkedin-insight'
import ReactPixel from '../../helpers/react-facebook-pixel-iyv'


@CSSModules(Styles,{allowMultiple:true})
export default class Link extends Component {
  static propTypes = {
    to: PropTypes.string.isRequired,
    strong: PropTypes.bool,
    light: PropTypes.bool,
    xstrong: PropTypes.bool,
    primarybutton: PropTypes.bool,
    transparentbutton: PropTypes.bool,
    transparentdonatebutton: PropTypes.bool,
    headerdonatebutton: PropTypes.bool,
    whitebutton: PropTypes.bool,
    orangebutton: PropTypes.bool,
    redbutton: PropTypes.bool,
    aboutmenu: PropTypes.bool,
    aboutmenuactive: PropTypes.bool,
    fundmenu: PropTypes.bool,
    fundmenuactive: PropTypes.bool,
    footer: PropTypes.bool,
    bigbutton: PropTypes.bool,
    donatebanner: PropTypes.bool,
    roundbutton: PropTypes.bool,
    log: PropTypes.object,
    linkedinTrack: PropTypes.number,
    title: PropTypes.string,
    targetBlank: PropTypes.bool,
    id: PropTypes.string,
    linkedin: PropTypes.string,
    fbPixel: PropTypes.bool,
  }

  constructor(props){
    super(props);
  }

  log = () => {
    if (this.props.log) {
      analytics.event(this.props.log)
    }
    // if (config.linkedinPid && this.props.linkedin) {
    //   LinkedInTag.track(this.props.linkedin)
    // }
    if (config.fbPixelId && this.props.fbPixel) {
      ReactPixel.track('Lead', {})
    }
  }

  render() {
    const title = this.props.title || this.props.to
    let styleName = 'link'
    if(this.props.strong){
      styleName = 'strong'
    }
    if(this.props.light){
      styleName = 'light'
    }
    if(this.props.xstrong){
      styleName = 'xstrong'
    }
    if(this.props.primarybutton){
      styleName = 'primarybutton'
    }
    if(this.props.transparentbutton){
      styleName = 'transparentbutton'
    }
    if(this.props.transparentdonatebutton){
      styleName = 'transparentdonatebutton'
    }
    if(this.props.headerdonatebutton){
      styleName = 'headerdonatebutton'
    }
    if(this.props.whitebutton){
      styleName = 'whitebutton'
    }
    if(this.props.orangebutton){
      styleName = 'orangebutton'
    }
    if(this.props.redbutton){
      styleName = 'redbutton'
    }
    if(this.props.aboutmenu){
      styleName = 'aboutmenu'
    }
    if(this.props.aboutmenuactive){
      styleName = 'aboutmenuactive'
    }
    if(this.props.fundmenu){
      styleName = 'fundmenu'
    }
    if(this.props.fundmenuactive){
      styleName = 'fundmenuactive'
    }
    if(this.props.footer){
      styleName = 'footer'
    }
    if(this.props.bigbutton){
      styleName = 'bigbutton'
    }
    if(this.props.roundbutton){
      styleName = 'roundbutton'
    }
    if(this.props.donatebanner){
      styleName = 'donatebanner'
    }
    //
    if (this.props.to.match(/^#/)){
      styleName += ' internal'
      return (
        <a
          styleName={styleName}
          onClick={this.log}
          title={title}
          href={this.props.to}
        >
          {this.props.children}
        </a>
      )
    }
    //
    if (
      this.props.to.match(/^http/) ||
      this.props.to.match(/^mailto/) ||
      this.props.targetBlank
    ){
      return (
        <a
          target='_blank'
          onClick={this.log}
          styleName={styleName}
          title={title}
          href={this.props.to}
        >
          {this.props.children}
        </a>
      )
    }
    //
    if (this.props.id) {
      return (
        <RouterLink
          styleName={styleName}
          onClick={this.log}
          title={title}
          to={this.props.to}
          id={this.props.id}
        >
          {this.props.children}
        </RouterLink>
      )
    }
    //
    return (
      <RouterLink
        styleName={styleName}
        onClick={this.log}
        title={title}
        to={this.props.to}
      >
        {this.props.children}
      </RouterLink>
    )
  }
}
